import { useEffect } from "react";

const useQuillTooltipPositioning = () => {
  useEffect(() => {
    const interval = setInterval(() => {
      const tooltip = document.querySelector(".ql-tooltip");
      const container = document.querySelector(".p-editor-container");

      if (!tooltip || !container || tooltip.classList.contains("ql-hidden")) return;

      const tooltipRect = tooltip.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      
      if (tooltipRect.width === 0 || tooltipRect.height === 0) return;

      let left = parseFloat(tooltip.style.left || "0");

      if (tooltipRect.left < containerRect.left) {
        tooltip.style.left = `${left + (containerRect.left - tooltipRect.left + 8)}px`;
      } else if (tooltipRect.right > containerRect.right) {
        tooltip.style.left = `${left - (tooltipRect.right - containerRect.right + 8)}px`;
      }
    }, 30);

    return () => clearInterval(interval);
  }, []);
};

export default useQuillTooltipPositioning;